import PrivacyPolicyLink from "../PrivacyPolicyLink";
import TermsLink from "../TermsLink";

const TermsAndPolicyLinks = () => (
  <>
    <TermsLink />
    <PrivacyPolicyLink />
  </>
);

export default TermsAndPolicyLinks;
